import { Component, Input, OnInit, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { Request, Http } from '@angular/http';

import { AuthService } from '../../services/auth.service';
// import { HeaderDirective } from '../../directives/header.directive';
// import { HeaderItem }      from '../header/header-item';
// import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'layout-header',
  template: `<div><ng-template sn-header></ng-template></div>`
})
export class HeaderLoaderComponent implements OnInit, OnDestroy {
  // @Input() headers: HeaderItem[];
  // @ViewChild(HeaderDirective) headerContainer: HeaderDirective;

  constructor(
      private componentFactoryResolver: ComponentFactoryResolver,
      private authService: AuthService
    ) { }

  ngOnInit() {
    this.loadComponent();
  }

  ngOnDestroy() {
  }

  loadComponent() {
  }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/header/header-loader.component.ts